import { render, staticRenderFns } from "./DeleteOfferItems.vue?vue&type=template&id=d12ad3cc&scoped=true"
import script from "./DeleteOfferItems.vue?vue&type=script&lang=ts"
export * from "./DeleteOfferItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12ad3cc",
  null
  
)

export default component.exports